import { useContext, VFC } from "react";
// Libraries
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router";
// API
import { GetBusinessUnits } from "api/BusinessUnits/types/GetBusinessUnits";
import { GET_ORGANISATIONS_LIST } from "api/Organisations/queries";
import { GetOrganizations } from "api/Organisations/types/GetOrganizations";
// Utils
import { AppContext } from "config/appProvider";
import { ANIMALS, DASHBOARD, TRADING } from "constants/Routes";
import { BU_TYPES } from "trading/constants";
import { setBUToLocalStorage, setBUTypeToLocalStorage, setFeaturesListToLocalStorage } from "helpers/storage";
import { useHasFeature } from "hooks";
// Types
import { InputSelectOptionWithTitles } from "components/Common/Field/Select";
// Components
import { InputSelect } from "components";

interface BusinessUnitSwitch {
  businessUnits: GetBusinessUnits["businessUnits"];
}

export const DashboardBusinessUnitSelect: VFC<BusinessUnitSwitch> = ({ businessUnits }) => {
  const { mainAppState, changeMainAppState } = useContext(AppContext);
  const currentBusinessUnitID = mainAppState.selectedBU.toString();
  const history = useHistory();

  const isShowHomePage = useHasFeature("SHOW_HOME_PAGE");
  const isProcessor = mainAppState.selectedBUType === BU_TYPES.processor;
  const pathToRedirect = isProcessor ? TRADING : ANIMALS;

  const { data: organisations } = useQuery<GetOrganizations>(GET_ORGANISATIONS_LIST, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });
  const userOrganisations = organisations?.organisations || [];
  const options = userOrganisations.reduce((result: InputSelectOptionWithTitles[], userOrg) => {
    result.push({
      key: userOrg?.organisation?.id || "key",
      label: userOrg?.organisation?.name || "",
    });
    (userOrg?.businessUnits || []).forEach((businessUnit) => {
      result.push({
        key: businessUnit?.id || "key",
        value: businessUnit?.id,
        label: businessUnit?.name || "",
      });
    });

    return result;
  }, []);

  const changeBusinessUnit = (newBusinessUnitID: string): void => {
    const newBusinessUnit = businessUnits?.find((businessUnit) => businessUnit?.id === newBusinessUnitID);
    const newBusinessUnitFoggles = newBusinessUnit?.foggles;
    const newBusinessUnitType = newBusinessUnit?.businessType?.slug;

    if (!newBusinessUnit || !newBusinessUnitFoggles || !newBusinessUnitType) return;

    setBUToLocalStorage(newBusinessUnitID);
    // @ts-ignore
    setFeaturesListToLocalStorage(newBusinessUnitFoggles);
    setBUTypeToLocalStorage(newBusinessUnitType);
    changeMainAppState({
      ...mainAppState,
      selectedBU: +newBusinessUnitID,
      selectedBUType: newBusinessUnitType,
      featuresList: newBusinessUnit?.foggles,
    });

    history.push(isShowHomePage ? DASHBOARD : pathToRedirect);
  };
  const handleChangeBusinessUnit = (event): void => changeBusinessUnit(event.target.value);

  return (
    <InputSelect
      name="businessUnitSwitcher"
      onChange={handleChangeBusinessUnit}
      options={options}
      value={options.length ? currentBusinessUnitID : ""}
    />
  );
};
